import styled from 'styled-components/macro';

export const EmptyTabContainer = styled.div`
  height: 100%;
  padding: 0px;
  z-index: 0;
  display: flex;
  flex-direction: row;
  align-items: center;

  animation-name: fadeIn;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const LeftSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 155px;
  overflow: hidden;
  padding: 0 40px 0 20px;

  img {
    width: 80px;
  }
`;

export const RightSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: calc(100% - 155px);

  h4 {
    font: normal 500 11px/17px Roboto;
  }

  p {
    font: normal 400 10px/16px Roboto;
  }
`;
